import script from "./MTournamentTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MTournamentTable.vue?vue&type=script&setup=true&lang=ts"

import "./MTournamentTable.vue?vue&type=style&index=0&id=ddf22186&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddf22186"]])

export default __exports__